import styled from 'styled-components'
import {LightGrey1} from '../../styles/SharedStyles'
import media from '../../styles/MediaQueries'

export const FooterContainer = styled.div`
    width: 100%;
    height: 89vh;

    display: flex;
    justify-content: center;
    align-items: flex-end;
    z-index: 100;
    position: relative;

`

export const ModalContainer = styled.div`
    width: 90vw;
    margin: 0 5%;
    padding: 5rem 0rem;

    ${media.largest`
        padding: 3rem 0rem;
    `}   

    ${media.medium`
        padding: 3rem 0 2rem 0;
    `}  

    ${media.smallest`
        padding: 3rem 0 2rem 0;
    `}  

    display: flex;
    justify-content: center;
    align-items: center;;
    z-index: 100;
    border-radius: 3px;

    background: #fff;

    position: absolute;
    top: -100%;
    left: 0;
    opacity: 0;
    transition: all 1s cubic-bezier(0.645, 0.045, 0.355, 1);
    cursor: auto;
    pointer-events: none;

    &.show {
        top: 10%;

        ${media.largest`
            top: 7.5%;
        `}   

        ${media.medium`
            top: 10%;
        `}  

        ${media.smallest`
            top: 5%;
        `}  
        opacity: 1;
        cursor: pointer;
        z-index: 1;
        pointer-events: auto;
    }

`

export const GridDiv = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 1fr;
    grid-gap: 10vw;

    ${media.medium`
        grid-gap: 7.5vw;
    `}  

    ${media.smallest`
        max-height: 70vh;
        grid-template-columns: 1fr;
        grid-template-rows: repeat(2, 1fr);
        grid-gap: 2vw;
        overflow-y: scroll;
    `}  
`

export const ColumnDiv = styled.div`
    ${'' /* border: 1px solid black; */}
    width: 45rem;

    ${media.largest`
        width: 35rem;
   `}   

   ${media.large`
        width: 30rem;
   `}   

   ${media.medium`
        width: 25rem;
   `} 

   ${media.smallest`
        width: 35rem;
    `}  


    h1 {
        font-size: 5.4rem;
        font-weight: 200;
        line-height: 1;
        padding-bottom: 2.5rem;
    }

    p {
        font-size: 1.6rem;
        font-weight: 300;
        color: ${LightGrey1};
        &:not(:last-of-type){
            padding-bottom: 1.25rem;
        }
        
        span {
            
        }
    }
`

export const FooterElement = styled.div`
    height: 8rem;

    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;

    a {
        color: #fff;
        font-weight: 800;
    }

    font-size: 1.2rem;
    font-weight: 300;
    line-height: 2;
`

export const About = styled(FooterElement)`
    position: absolute;
    bottom: 45vh;
    cursor: pointer;

    font-size: 3.2rem;
    font-weight: 200;
`